import "./main.scss"
import "bootstrap"
import $ from "jquery"
import Papa from "papaparse"
import playlistDataUrl from "./data.csv"
import { dataPeople, dataBeep } from "./data"
import { PersonModel, PlaylistItemModel, PlaylistItemGroupModel } from "./model"
import { render } from "./utils"
import { Player } from "./player"
import { People, PersonState } from "./people"

type Event = "activeItemChanged"

(function() {
    $(function () {
        const indexPeople:Map<string, PersonModel> = dataPeople.reduce((prev:Map<string, PersonModel>, cur:PersonModel) => prev.set(cur.id, cur), new Map())
        const muteState:Map<String,boolean> = dataPeople.reduce((prev, cur) => prev.set(cur.id, false), new Map())
        
        var $tmplPlaylistItemGroup = $('script[data-template="playlist-item-group"]').text().split(/\$\{(.+?)\}/g)
        var $tmplPlaylistItem = $('script[data-template="playlist-item"]').text().split(/\$\{(.+?)\}/g)
        
        const $scenesContainer = $("#scenes-container")
        let $allPlaylistItems = $([])
        
        let peopleContainer = $([])
        
        // plater
        const player = new Player({
            container: $("#audio-container"),
            beepSource: dataBeep.source
        })
        player.onPlaybackFinished(() => {
            if(isAutoPlayEnabled()) {
                let next = playlistFindNext()
                setItem(next)
                playItem(next)
            }
        })
        on("activeItemChanged", (e:any, activeItem:JQuery) => {
            let mainModel = $(activeItem).data("model") as PlaylistItemModel
            if(mainModel) {
                player.set(mainModel.source)
            }
        })
        // end player

        // text
        var $textContainer = $("#text-container").hide()
        on("activeItemChanged", (e:any, activeItem:JQuery) => {
            const itemModel = $(activeItem).data("model") as PlaylistItemModel
            const text = itemModel? itemModel.text : ""
            $textContainer.find(".content").text(text)
        })
        // end text

        // people
        const people = new People({
            componentReady: (node:JQuery) => {
                peopleContainer = node
                $textContainer.after(node)
            },
            data: dataPeople
        })
        people.onMuteStateChanged((model:PersonModel, state:PersonState) => {
            muteState.set(model.id, state.muted)
        })
        people.onMeModeStateChanged((model:PersonModel, state:PersonState) => {
            if(state.meMode) {
                $allPlaylistItems.not(".playlist-item-" + model.id).addClass("disabled")
                $allPlaylistItems.filter(".playlist-item-" + model.id).removeClass("disabled")
                setItem($([]))
            } else {
                $allPlaylistItems.removeClass("disabled")
                setItem($([]))
            }
        })
        // end people
            
        var $controlsContainer = $("#controls-container")
        var $peopleContainerControl = $controlsContainer.find("#people-control")
        $peopleContainerControl.on("change", (e:JQuery.ChangeEvent) => {
            $(e.currentTarget).is(":checked")? peopleContainer.show() : peopleContainer.hide()
        })
        $peopleContainerControl.prop("checked", true).trigger("change")
        
        // text control
        var $textContainerControl = $controlsContainer.find("#text-control")    
        $textContainerControl.on("change", (e:JQuery.ChangeEvent) => {
            $(e.currentTarget).is(":checked")? $allPlaylistItems.find(".subtitles").addClass("show-global") : $allPlaylistItems.find(".subtitles").removeClass("show-global")
        })
        $textContainerControl.prop("checked", false).trigger("change")
        // end text control

        // autoplay control
        var $autoplayControl = $controlsContainer.find("#autoplay-control")
        
        $(".main-content").on("touchstart", handleSwipeStart)
        $(".main-content").on("touchmove", detectSwipe)

        loadPlaylistData(playlistDataUrl).then(dataPlaylist => {
            $scenesContainer.append(dataPlaylist.map(renderPlaylistItemGroup.bind(null, $tmplPlaylistItemGroup)))
            $allPlaylistItems = $scenesContainer.find(".list-group .list-group-item")

            setItem($([]))
        })

        function setItem(activeItem:JQuery) {
            if(activeItem.length == 0) {
                const availableItems = $allPlaylistItems.not(".disabled")
                activeItem = availableItems.filter(".active")
                if(activeItem.length == 0) {
                    activeItem = availableItems.first()
                }
            }

            $allPlaylistItems.removeClass("active")
            activeItem.addClass("active")

            $scenesContainer.trigger("activeItemChanged", activeItem)
        }
        
        function playItem($item:JQuery) {
            if($item.length == 0) {
                return
            }

            let model = $item.data("model") as PlaylistItemModel
            player.maskEnabled(isPersonMuted(model.personId))
            player.play()
        }

        function isPersonMuted(personId:string) {
            return muteState.get(personId) === true
        }

        function isAutoPlayEnabled() {
            return $autoplayControl.is(":checked")
        }

        function playlistFindNext(item?:JQuery):JQuery {
            if(!item) {
                item = $allPlaylistItems.filter(".active")
            }

            if(item.length == 0) {
                console.warn("No active element set or provided element is empty")
                return $([])
            }

            let startIndex = $allPlaylistItems.index(item)
            if(startIndex == -1) {
                console.warn("Invalid element provided as an argument: " + item)
                return $([])
            }

            let nextIndex = startIndex + 1
            if(nextIndex >= $allPlaylistItems.length) {
                nextIndex = 0;
            }
            
            while(nextIndex != startIndex) {
                let nextItem = $allPlaylistItems.eq(nextIndex)

                if(nextItem.hasClass("disabled")) {
                    nextIndex = nextIndex + 1
                    if(nextIndex >= $allPlaylistItems.length) {
                        nextIndex = 0;
                    }
                } else {
                    return nextItem
                }
            }

            return $([])
        }

        function playlistFindPrev(item?:JQuery):JQuery {
            if(!item) {
                item = $allPlaylistItems.filter(".active")
            }
            
            if(item.length == 0) {
                console.warn("No active element set or provided element is empty")
                return $([])
            }

            let startIndex = $allPlaylistItems.index(item)
            if(startIndex == -1) {
                console.warn("Invalid element provided as an argument: " + item)
                return $([])
            }

            let nextIndex = startIndex - 1
            if(nextIndex < 0) {
                nextIndex = $allPlaylistItems.length - 1
            }
            
            while(nextIndex != startIndex) {
                let nextItem = $allPlaylistItems.eq(nextIndex)

                if(nextItem.hasClass("disabled")) {
                    nextIndex = nextIndex - 1
                    if(nextIndex < 0) {
                        nextIndex = $allPlaylistItems.length - 1
                    }
                } else {
                    return nextItem
                }
            }

            return $([])
        }

        function handleSwipeStart(e:JQuery.TouchStartEvent) {
            if(e.touches.length == 0) return
            const currPosX = e.touches[0].screenX
            $(e.target).data("touchstart.x", currPosX)
        }

        function detectSwipe(e:JQuery.TouchMoveEvent) {
            if(e.touches.length == 0) return
            
            const prevPosX = $(e.target).data("touchstart.x")
            if(!prevPosX) return
            
            const currPosX = e.touches[0].screenX
            if(!currPosX) return

            const diff = currPosX - prevPosX
            if(diff > 50) {
                $(e.target).removeData("touchstart.x")
                
                const nextItem = playlistFindNext()
                setItem(nextItem)
                playItem(nextItem)
            } else if(diff < -50) {
                $(e.target).removeData("touchstart.x")

                const nextItem = playlistFindPrev()
                setItem(nextItem)
                playItem(nextItem)
            }
        }

        function on(e:Event, callback: (target:any, ...args:any[]) => void) {
            $scenesContainer.on(e, callback)
        }

        // rendering
        function renderPlaylistItemGroup(template:Array<string>, model:PlaylistItemGroupModel) {
            var $item = $(template.map(render(model)).join(''))
            $item.find("#" + model.id + "-items")
                .append(model.items.map(renderPlaylistItem.bind(null, $tmplPlaylistItem, model)))
            return $item
        }

        function renderPlaylistItem(template:Array<string>, groupModel:PlaylistItemGroupModel, model:PlaylistItemModel, index:number) {
            var templateProps = Object.assign({id: groupModel.id + model.name.substring(1), person: indexPeople.get(model.personId)}, model)
            var $item = $(template.map(render(templateProps)).join(''))
                .data("model", model)

            $item.on("click", (event:JQuery.ClickEvent) => {
                const currentTarget = $(event.currentTarget)
                setItem(currentTarget)
                playItem(currentTarget)
            }).on("change", ".subtitles-control", (event:JQuery.ChangeEvent) => {
                event.stopPropagation()
                $(event.target).is(":checked")? $item.find(".subtitles").addClass("show-subtitles") : $item.find(".subtitles").removeClass("show-subtitles")
            })
            
            $item.find(".subtitles-control-label").parent().on("click", (event:JQuery.ClickEvent) => {
                event.stopPropagation()
            })
            
            return $item
        }

        function loadPlaylistData(url:String):Promise<PlaylistItemGroupModel[]> {
            return new Promise<PlaylistItemGroupModel[]>((resolve, reject) => {
                Papa.parse(playlistDataUrl, {
                    download: true,
                    header: true,
                    complete: (results:Papa.ParseResult<PlaylistItemModel>) => {
                        let indexToScene = new Array<String>()
                        
                        resolve(results.data.reduce<PlaylistItemGroupModel[]>(
                            (prev:PlaylistItemGroupModel[], cur:PlaylistItemModel) => {
                                const targetId = "scene" + cur.part + "" + cur.scene
                                
                                if(indexToScene.indexOf(targetId) < 0) {
                                    indexToScene.push(targetId)
                                }
                                
                                const index = indexToScene.indexOf(targetId)
                                prev[index] = prev[index] || {
                                    id: targetId,
                                    name: "Akt " + cur.part + " - Scena " + cur.scene,
                                    part: cur.part,
                                    scene: cur.scene,
                                    items: []
                                }

                                prev[index].items.push(cur)
                                return prev
                        }, []))
                    }
                })
            })
        }
    })
})()